<template>
  <div>
      <el-dialog :visible.sync="centerDialogVisible" width="30%" center @close="handleClose">
          <div style="text-align: center; color: orange;">{{"感谢观看此视频"}}</div>
      </el-dialog>
    <div @contextmenu.prevent class="w">
        <div class="video_page">
        <div class="vedio_top">
          <div class="vedio_tit">
            <img
              @click="goBack"
              src="../../assets/img/study/video/icon_fanhui2.png"
              alt
            />
            <div>{{ vedioTitle }}</div>
          </div>
        </div>
            <div class="vedio_body" :style="conheight">
          <div class="prism-player" id="playerId" :style="playStyle" >
          </div>
         <!-- <video
            controls
            autoplay
            muted
            controlslist="nodownload"
            :src="play_url"
            id="media"
            :style="{ width: vedioWidth2 }"
          ></video>-->
          <div class="vedio_rt" :style="{ width: vedioWidth }">
            <!-- 收起按钮 -->
            <div v-if="widthBtn" @click="changeVedioWidth(0)" class="toWidth">
              <img
                style="transform: rotate(180deg)"
                src="../../assets/img/study/video/left.png"
                alt
              />
              <!-- <img src="../../assets/img/study/video/icon_shouqi.png" alt /> -->
            </div>
            <!-- 展开按钮 -->
            <div v-else @click="changeVedioWidth(1)" class="toWidth toWidth2">
              <img src="../../assets/img/study/video/icon_shouqi.png" alt />
            </div>
            <!-- tabs切换 -->
            <div class="vedio_tabs">
              <div
                @click="changeTab(index)"
                :class="{ tabActive: tabActive == index }"
                class="tabsList"
                v-for="(item, index) in tabsList"
                :key="index"
              >
                {{ item }}
              </div>
            </div>
            <!-- 目录列表 -->
            <div v-if="tabActive == 0" class="kechengList">
              <div class="kecehng_gi_box">
                <div
                  :class="{ jie_active: jie_active == index }"
                  class="mulu_jie"
                  v-for="(item1, index) in menuList"
                  :key="index"

                  @click="changeVedio(item1.id, index)"
                >
                  <div class="jie_left">
                    <!-- <img v-if="jie_active==index" src="../../assets/image/icon_lubo2.png" /> -->
                    <!-- <img v-else src="../../assets/image/icon_lubo1.png" /> -->
                    <div :class="{ jie_active2: jie_active == index }">
                      {{ item1.vname }}
                    </div>
                  </div>
                  <div class="jie_rigtht">
                    <div
                      :class="{ jie_active2: jie_active == index }"
                      class="shiting"
                      v-if="item1.finish == 1"
                    >
                      <img
                              src="../../assets/img/study/video/end.png"
                              alt
                      />
                    </div>
                    <div
                      :class="{ jie_active2: jie_active == index }"
                      class="shiting"
                      v-else
                    >
                        <img src="../../assets/img/study/video/play.png" alt/>
                    </div>
                    <!-- <div class="buy">需要购买</div> -->
                  </div>
                </div>
              </div>
            </div>
            <!-- 答疑 -->
            <div v-if="tabActive == 1">
              <div class="biji_box">
                <div class="biji_top">
                  <textarea
                    name
                    id
                    placeholder="请输入内容"
                    v-model="dayiContent"
                  ></textarea>
                  <div v-if="widthBtn" class="biji_btn" @click="addDayi">提交</div>
                </div>
                <div class="biji_list">
                  <div class="biji_list_top">
                    <div class="list_title">答疑({{ dayiList.length }})</div>
                    <!-- <div class="rrrow">
                      <div v-if="pre == true" class="tips tips1">上一页</div>
                      <div v-if="next == true" class="tips tips1">下一页</div>
                    </div> -->
                  </div>
                  <div class="none" v-if="dayiList.length == 0">暂无答疑</div>
                  <div v-else class="biji_list_box2">
                    <div
                      class="biji_list_body"
                      v-for="(item, index) in dayiList"
                      :key="index"
                    >
                        <div class="comment-class">
                            <!--<img src="../assets/img/home/img8.png" style="width: 105px; height: 105px;" />-->
                            <div v-if="parseInt(item.sex) == 1">
                                <!--<div class="name" style="padding-top: 15px;font-size: 20px;">{{ userInfo.username }}</div>-->
                                <img
                                        class="gender"
                                        src="../../assets/img/home/girl.jpg"
                                        style="width: 50px; height: 50px; float: left!important;"
                                />
                            </div>

                            <div v-else>

                                <img
                                        class="gender"
                                        src="../../assets/img/home/boy.jpg"
                                        style="width: 50px; height: 50px;float: left!important;"
                                />
                            </div>
                        </div>

                        <div class="comment-class" style="margin-bottom: 20px;">
                            <p style="font-size: 16px;color: deepskyblue;">
                                <i>{{item.userName}}</i>
                            </p>
                            <p style="font-size: 12px;">
                                <i>{{(item.addtime * 1000) | dateFormat }}</i>
                            </p>
                            <p style="font-size: 14px; color: #f5f8bf;">
                                <i>{{item.content}}</i>
                            </p>

                        </div>

<!--                      答疑回复模块-->


<!--                        <div class="comment-class" @click="showCont(index)" style="float: right;">-->
<!--                            <img-->
<!--                                    src="../../assets/img/study/答疑/icon-20.png"-->
<!--                                    style="width: 20px; height: 20px; float: left!important;"-->
<!--                            />-->
<!--                        </div>-->

<!--                        <div v-if="(index == index1) ">-->
<!--                            <input v-model="item.id" hidden/>-->
<!--                            <textarea v-model="contents" placeholder="回复内容"></textarea>-->
<!--                            <div class="btn" style="display: block;">-->

<!--                                    <span slot="footer" class="dialog-footer">-->
<!--                                      <el-button @click="resets"> 取消 </el-button>-->
<!--                                      <el-button type="primary" @click="submitForms(item,contents)"> 发送 </el-button>-->
<!--                                    </span>-->

<!--                            </div>-->
<!--                        </div>-->


                        <!--<div class="biji_content">
                        {{ item.content }}
                      </div>
                        <div>
                            {{item.userName}}
                        </div>
                      <div class="biji_btm">
                        <div class="btm_left">

                          {{ (item.addtime * 1000) | dateFormat }}
                        </div>
                      </div>-->
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 笔记 -->
            <div v-if="tabActive == 2">
              <div class="biji_box">
                <div class="biji_top">
                  <textarea
                    name
                    id
                    placeholder="请输入笔记内容"
                    v-model="noteContent"
                  ></textarea>
                  <div v-if="widthBtn" class="biji_btn" @click="addNote">提交</div>
                </div>
                <div class="biji_list">
                  <div class="biji_list_top">
                    <div class="list_title">笔记({{ noteList.length }})</div>
                    <!-- <div class="rrrow">
                      <div v-if="pre == true" class="tips tips1">上一页</div>
                      <div v-if="next == true" class="tips tips1">下一页</div>
                    </div> -->
                  </div>
                  <div class="none" v-if="noteList.length == 0">暂无笔记</div>
                  <div v-else class="biji_list_box2">
                    <div
                      class="biji_list_body"
                      v-for="(item, index) in noteList"
                      :key="index"
                    >
                      <div class="biji_content">
                        {{ item.note }}
                      </div>

                      <div class="biji_btm">
                        <div class="btm_left">
                          {{ (item.addtime * 1000) | dateFormat }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
    submitAnswer,
  videoTime,
  getVedioList,
  getVedioBiji,
  addNote,
  vedioFinish,
   videoWatch,
  getDayiList,
  submitDayi,
} from "../../assets/js/api.js";
import md5 from 'js-md5';
import store from "store";
export default {
    name: "Aliplayer",
    props: {
        playStyle: {
            type: String,
            default: ""
        },
        aliplayerSdkPath: {
            // Aliplayer 代码的路径
            type: String,
            default: "//g.alicdn.com/de/prismplayer/2.9.1/aliplayer-min.js"
        },
        autoplay: {
            type: Boolean,
            default: true
        },
        isLive: {
            type: Boolean,
            default: false
        },
        disableSeek:{
          type:Boolean,
          default: false
        },
        playsinline: { // H5是否内置播放，有的Android浏览器不起作用。
            type: Boolean,
            default: false
        },
        width: {
            type: String,
            default: "100%"
        },
        height: {
            type: String,
            default: "100%"
        },
        controlBarVisibility: { // 控制面板的实现，默认为‘hover’， 可选的值为：‘click’、‘hover’、‘always’。
            type: String,
            default: "hover"
        },
        useH5Prism: {
            type: Boolean,
            default: true
        },
        useFlashPrism: {
            type: Boolean,
            default: false
        },
        vid: {
            type: String,
            default: ""
        },
        playauth: {
            type: String,
            default: ""
        },
        source: {
            type: String,
            default: ""
        },
        cover: {
            type: String,
            default: ""
        },
        format: {
            type: String,
            default: "m3u8"
        },
        skinLayout: {
            type: Array,
            default: function() {
                return [];
            }
        },

        x5_video_position: {
            type: String,
            default: "top"
        },
        x5_type: {
            type: String,
            default: "h5"
        },
        x5_fullscreen: {
            type: Boolean,
            default: false
        },
        x5_orientation: {
            type: Number,
            default: 2
        },
        autoPlayDelay: {
            type: Number,
            default: 0
        },
        autoPlayDelayDisplayText: {
            type: String
        }
    },


    data() {
    return {
      setTime:undefined,
        conheight: {
            height: ''
        },
        contents: "",
        show: false,
        index1:-1,
        data: "",
      player: {},
      old_id: 0,
      vedioTitle: "",
        centerDialogVisible: false,
      id: "",
      play_url: "",
      // 视频右侧宽度
      vedioWidth: "27%",
      vedioWidth2: "73%",
      //视频当前播放时长
      // vedioWidth2: "900px",
      widthBtn: true,
      pinglunNum: 3,
      edit: -1,
      del: -1,
      pre: false,
      next: false,
      bijiNum: 6,
      tabActive: 0,
      finish:0,
      tabsList: ["目录", "答疑", "笔记"],
      jie_active: 0,
      shiting_active: -1,
      jie_active2: -1,
      shiting_active2: -1,
      menuList: [],
      piangjiaList: [1, 2, 3, 4, 5, 6],
      c_id: "",
      c_s_id: "",
      // 笔记列表
      noteList: [],
      // 答疑列表
      dayiList: [],
      // 笔记内容
      noteContent: "",
      // 答疑内容
      dayiContent: "",
      video_id: "",
      culum_id: "",
      user_id: "",
      // 当前播放进度
      now_time: "",
      video_time: 0,
      playTime: "",
      playerId: "playerId",
      scriptTagStatus: 0,
      isReload: false,
        instance: null,
        order: true,

    };
  },
  mounted() {
    this.id = this.$route.query.id;

      this.getVideoList();

      if (window.Aliplayer !== undefined) {
          // 如果全局对象存在，说明编辑器代码已经初始化完成，直接加载编辑器
          this.scriptTagStatus = 2;
          this.initAliplayer();
      } else {
          // 如果全局对象不存在，说明编辑器代码还没有加载完成，需要加载编辑器代码
          this.insertScriptTag();
      }

  },


    destroyed(){
      this.watchTime()
    },
  created() {
      this.index1 = -1
      if (window.Aliplayer !== undefined) {
          // 如果全局对象存在，说明编辑器代码已经初始化完成，直接加载编辑器
          this.scriptTagStatus = 2;
          this.initAliplayer();
      } else {
          // 如果全局对象不存在，说明编辑器代码还没有加载完成，需要加载编辑器代码
          this.insertScriptTag();
      }

      // window.onkeydown = window.onkeyup = window.onkeypress = function (event) {
      //     // 判断是否按下F12，F12键码为123
      //     if (event.keyCode == 123) {
      //         event.preventDefault(); // 阻止默认事件行为
      //         window.event.returnValue = false;
      //     }
      // };
      window.addEventListener('resize', this.getHeight);
      this.getHeight()
  },

  methods: {
      getHeight() {
          this.conheight.height = window.innerHeight - 40 + 'px';
      },
      submitForms(item, contents) {

        if (!contents) {
          this.$message.error("请输入内容！");
          return;
        }

          submitAnswer(window.localStorage.getItem("siteId"), window.localStorage.getItem("info"), this.id, contents,this.c_s_id,  item.id, 5, item.uid).then(res => {
              this.$message.success("发送成功")
          })
          this.contents = ""
      },
      resets() {
          this.index1 = -1;
          this.show = false;
          this.contents = ""
      },
      showCont: function (index) {
          this.index1 = index;
          this.show = !this.show;
      },

      insertScriptTag() {
          const _this = this;
          let playerScriptTag = document.getElementById("playerScriptTag");
          // 如果这个tag不存在，则生成相关代码tag以加载代码
          if (playerScriptTag === null) {
              playerScriptTag = document.createElement("script");
              playerScriptTag.type = "text/javascript";
              playerScriptTag.src = this.aliplayerSdkPath;
              playerScriptTag.id = "playerScriptTag";
              let s = document.getElementsByTagName("head")[0];
              s.appendChild(playerScriptTag);
          }
          if (playerScriptTag.loaded) {
              _this.scriptTagStatus++;
          } else {
              playerScriptTag.addEventListener("load", () => {
                  _this.scriptTagStatus++;
                  playerScriptTag.loaded = true;
                  _this.initAliplayer();
              });
          }
          _this.initAliplayer();
      },
      initAliplayer() {
          const _this = this;
          // scriptTagStatus 为 2 的时候，说明两个必需引入的 js 文件都已经被引入，且加载完成
          if ( _this.scriptTagStatus === 2 && (_this.instance === null || _this.reloadPlayer) ) {
              _this.instance && _this.instance.dispose();
              // console.log(document.querySelector("#" + _this.playerId));

              // document.querySelector("#" + _this.playerId).innerHTML = "";
              // Vue 异步执行 DOM 更新，这样一来代码执行到这里的时候可能 template 里面的 script 标签还没真正创建
              // 所以，我们只能在 nextTick 里面初始化 Aliplayer
              _this.$nextTick(() => {
                  _this.instance = window.Aliplayer({
                      id: _this.playerId,
                      autoplay: _this.autoplay,
                      isLive: _this.isLive,
                      playsinline: _this.playsinline,
                      format: _this.format,
                      width: _this.width,
                      height: _this.width,
                      controlBarVisibility: _this.controlBarVisibility,
                      useH5Prism: _this.useH5Prism,
                      useFlashPrism: _this.useFlashPrism,
                      vid: _this.vid,
                      skinLayout: [
                          {
                              name: "bigPlayButton",
                              align: "blabs",
                              x: 30,
                              y: 80
                          },
                          {
                              name: "H5Loading",
                              align: "cc"
                          },
                          {
                              name: "errorDisplay",
                              align: "tlabs",
                              x: 0,
                              y: 0
                          },
                          {
                              name: "infoDisplay"
                          },
                          {
                              name: "tooltip",
                              align: "blabs",
                              x: 0,
                              y: 56
                          },
                          {
                              name: "thumbnail"
                          },
                          {
                              name: "controlBar",
                              align: "blabs",
                              x: 0,
                              y: 0,
                              children: [
                                  {
                                      name: "playButton",
                                      align: "tl",
                                      x: 15,
                                      y: 12
                                  },
                                  {
                                      name: "timeDisplay",
                                      align: "tl",
                                      x: 10,
                                      y: 7
                                  },
                                  {
                                      name: "fullScreenButton",
                                      align: "tr",
                                      x: 10,
                                      y: 12
                                  },
                                  {
                                      name: "volume",
                                      align: "tr",
                                      x: 5,
                                      y: 10
                                  }
                              ]
                          }
                      ],
                      playauth: _this.playauth,
                      source: _this.source,
                      cover: _this.cover,
                      // 说明：功能组件布局配置，不传该字段使用默认布局传false隐藏所有功能组件，请参照皮肤定制
                      x5_video_position: _this.x5_video_position,
                      x5_type: _this.x5_type,
                      x5_fullscreen: _this.x5_fullscreen,
                      x5_orientation: _this.x5_orientation,
                      autoPlayDelay: _this.autoPlayDelay,
                      autoPlayDelayDisplayText: _this.autoPlayDelayDisplayText
                  });
                  // 绑定事件，当 AliPlayer 初始化完成后，将编辑器实例通过自定义的 ready 事件交出去
                  _this.instance.on("ready", () => {
                      this.$emit("ready", _this.instance);
                  });
                  _this.instance.on("play", () => {
                      this.$emit("play", _this.instance);
                  });
                  _this.instance.on("pause", () => {
                      this.$emit("pause", _this.instance);
                  });
                  _this.instance.on("ended", () => {
                      this.$emit("ended", _this.instance);
                  });
                  _this.instance.on("liveStreamStop", () => {
                      this.$emit("liveStreamStop", _this.instance);
                  });
                  _this.instance.on("m3u8Retry", () => {
                      this.$emit("m3u8Retry", _this.instance);
                  });
                  _this.instance.on("hideBar", () => {
                      this.$emit("hideBar", _this.instance);
                  });
                  _this.instance.on("waiting", () => {
                      this.$emit("waiting", _this.instance);
                  });
                  _this.instance.on("snapshoted", () => {
                      this.$emit("snapshoted", _this.instance);
                  });

                  _this.instance.on("timeupdate", () => {
                      _this.$emit("timeupdate", _this.instance);
                  });
                  _this.instance.on("requestFullScreen", () => {
                      _this.$emit("requestFullScreen", _this.instance);
                  });
                  _this.instance.on("cancelFullScreen", () => {
                      _this.$emit("cancelFullScreen", _this.instance);
                  });
                  _this.instance.on("error", () => {
                      _this.$emit("error", _this.instance);
                  });
                  _this.instance.on("startSeek", () => {
                      _this.$emit("startSeek", _this.instance);
                  });
                  _this.instance.on("completeSeek", () => {
                      _this.$emit("completeSeek", _this.instance);
                  });
              });
          }
      },
      /**
       * 播放视频
       */
      play: function() {
          this.instance.play();
      },
      /**
       * 暂停视频
       */
      pause: function() {
          this.instance.pause();
      },
      /**
       * 重播视频
       */
      replay: function() {
          this.instance.replay();
      },
      /**
       * 跳转到某个时刻进行播放
       * @argument time 的单位为秒
       */
      seek: function(time) {
          this.instance.seek(time);
      },
      /**
       * 获取当前时间 单位秒
       */
      getCurrentTime: function() {
          return this.instance.getCurrentTime();
      },
      /**
       *获取视频总时长，返回的单位为秒
       * @returns 返回的单位为秒
       */
      getDuration: function() {
          return this.instance.getDuration();
      },
      /**
       获取当前的音量，返回值为0-1的实数ios和部分android会失效
       */
      getVolume: function() {
          return this.instance.getVolume();
      },
      /**
       设置音量，vol为0-1的实数，ios和部分android会失效
       */
      setVolume: function(vol) {
          this.instance.setVolume(vol);
      },
      /**
       *直接播放视频url，time为可选值（单位秒）目前只支持同种格式（mp4/flv/m3u8）之间切换暂不支持直播rtmp流切换
       *@argument url 视频地址
       *@argument time 跳转到多少秒
       */
      loadByUrl: function(url, time) {
          this.instance.loadByUrl(url, time);
      },

      /**
       * 设置播放速度
       *@argument speed 速度
       */
      setSpeed: function(speed) {
          this.instance.setSpeed(speed);
      },
      /**
       * 设置播放器大小w,h可分别为400px像素或60%百分比chrome浏览器下flash播放器分别不能小于397x297
       *@argument w 播放器宽度
       *@argument h 播放器高度
       */
      setPlayerSize: function(w, h) {
          this.instance.setPlayerSize(w, h);
      },
      /**
       * 目前只支持HTML5界面上的重载功能,暂不支持直播rtmp流切换m3u8）之间切换,暂不支持直播rtmp流切换
       *@argument vid 视频id
       *@argument playauth 播放凭证
       */
      reloaduserPlayInfoAndVidRequestMts: function(vid, playauth) {
          this.instance.reloaduserPlayInfoAndVidRequestMts(vid, playauth);
      },
      reloadPlayer: function() {
          this.isReload = true;
          this.initAliplayer();
          this.isReload = false;
      },

      // 记录当前播放进度
      watchTime() {
          console.log(this.getCurrentTime(), "时间播放进度")
          this.now_time = this.getCurrentTime()
          videoWatch(localStorage.getItem("siteId"),localStorage.getItem("info"),this.c_s_id,this.now_time).then(res => {
              console.log("保存进度")
          });

      },

    // 获取视频信息
      getVideoList() {
      getVedioList(window.localStorage.getItem("siteId"),window.localStorage.getItem("info"),this.id).then((res) => {
        if (res.code == 200) {
            console.log(res, "视频获取")
          this.vedioTitle = res.data.videoVos[0].vname;
          this.menuList = res.data.videoVos;

          // console.log("课程列表" + JSON.stringify(this.menuList))

          this.setTime = localStorage.getItem("setTime")
          this.play_url = res.data.videoVos[0].address;
          this.now_time = res.data.videoVos[0].nowTime
          //视频Id
          this.c_s_id = res.data.videoVos[0].id;
          //课程ID
          this.c_id = res.data.id;

          this.loadByUrl("https://file.hnzkw.org.cn/" + this.play_url, this.now_time)

          // /**
          //  * 视频鉴权
          //  * @type {string}
          //  */
          // let url = "https://file.hnzye.com/" + this.play_url;
          // // url = this.encode(url);
          // let url1 = encodeURIComponent(url);
          // let key = "hnzyjy";
          // let time = new Date().getMilliseconds();
          // let hashValue = md5(url1+"-"+time+"-0-0-"+key);
          // let url2 = url1+"?auth_key="+time+"-0-0-"+hashValue;
          //
          // this.loadByUrl(url2, this.now_time)



          //此处新增setTime判断(不设置则默认看完视频完成)  by 2021-03-08
          if(this.setTime > 0){
            this.instance.on("timeupdate", () => {
              if (Math.ceil(this.getCurrentTime()) == (this.setTime > 0 ? this.setTime : 10) && this.order == true) {
                this.centerDialogVisible = true
                this.pause()
                this.order = false
                vedioFinish(localStorage.getItem("siteId"), window.localStorage.getItem("info"), this.c_s_id, this.getCurrentTime()).then((res) => {

                });
              }

            })
          }

          //视频完整播放
          this.instance.on("ended",() => {
              this.now_time = this.getCurrentTime()
              vedioFinish(localStorage.getItem("siteId"),window.localStorage.getItem("info"),this.c_s_id,this.now_time).then((res) => {
                // this.centerDialogVisible = true
                getVedioList(window.localStorage.getItem("siteId"), window.localStorage.getItem("info"), this.id).then(res => {
                  this.menuList = res.data.videoVos;
                });
              });
          })
        }
      });
    },

      handleClose() {

          this.play()
          getVedioList(window.localStorage.getItem("siteId"), window.localStorage.getItem("info"), this.id).then(res => {
              console.log(res.data.videoVos, "获取视频")
              this.menuList = res.data.videoVos;
          });
      },

    // 切换视频
    changeVedio(id, i) {
        this.order = true
      this.watchTime()
      this.c_s_id = id;
      this.jie_active = i;
      videoTime(localStorage.getItem("siteId"),localStorage.getItem("info"),this.c_s_id,this.now_time).then(res =>{
          this.vedioTitle = res.data.vname;
          this.play_url = res.data.address;
          this.now_time = res.data.nowTime;
          this.finish = res.data.finish

          this.loadByUrl("https://file.hnzkw.org.cn/" + this.play_url, this.now_time)

        // /**
        //  * 视频鉴权
        //  * @type {string}
        //  */
        //   let url = "https://file.hnzye.com/" + this.play_url;
        //   // url = this.encode(url);
        //   let url1 = encodeURIComponent(url);
        //   let key = "hnzyjy";
        //   let time = new Date().getMilliseconds();
        //   let hashValue = md5(url1+"-"+time+"-0-0-"+key);
        //   let url2 = url1+"?auth_key="+time+"-0-0-"+hashValue;
        //   this.loadByUrl(url2, this.now_time)

      })


    },
    // 获取笔记列表
    getVedioBiji() {
      getVedioBiji(window.localStorage.getItem("siteId"),window.localStorage.getItem("info"),this.c_s_id).then((res) => {
        if (res.code == 200) {
          this.noteList = res.data;
        }
      });
    },
    // 获取答疑列表
    getDayiList() {
      getDayiList(window.localStorage.getItem("siteId"),window.localStorage.getItem("info"),this.c_s_id).then((res) => {
        if (res.code == 200) {
          this.dayiList = res.data;
        }
      });
    },
    // 添加笔记
    addNote() {
      if (!this.noteContent) {

        this.$message.error("请输入笔记内容！");
        return;
      }

      addNote(window.localStorage.getItem("siteId"),window.localStorage.getItem("info"),this.c_s_id, this.id,this.noteContent).then((res) => {
        if (res.code == 200) {
          this.$message.success("笔记添加成功");
          this.noteContent = "";
          this.getVedioBiji();
        }
      });
    },
    // 提交答疑
    addDayi() {
      if (!this.dayiContent) {
        this.$message.error("请输入内容！");
        return;
      }
      submitDayi(window.localStorage.getItem("siteId"),window.localStorage.getItem("info"),this.id, this.dayiContent, this.c_s_id, 5).then((res) => {
        console.log(res);
        if (res.code == 200) {
          this.$message.success("提交成功");
          this.dayiContent = "";
          this.getDayiList();
        }
      });
    },
    // 展开与收起
    changeVedioWidth(i) {
      let myVideo = document.getElementById("media");
      if (i == 0) {
        this.vedioWidth = "1px";
        this.vedioWidth2 = "100%";
        // myVideo.width = 1000;
        this.widthBtn = !this.widthBtn;
      } else {
        this.vedioWidth = "27%";
        this.vedioWidth2 = "73%";
        // myVideo.width = 800;
        this.widthBtn = !this.widthBtn;
      }
    },
    changeTab(i) {
      this.tabActive = i;
      if (i == 2) {
        this.getVedioBiji();
      } else {
        if (i == 1) {
          this.getDayiList();
        }
      }
    },
    goBack() {
      this.$router.go(-1);
    },


  },

};
</script>
<style lang="postcss" scoped>
    @import 'https://g.alicdn.com/de/prismplayer/2.9.1/skins/default/aliplayer-min.css';
</style>
<style lang="less" scoped>
// 隐藏滚动条
.pingjia_body_list::-webkit-scrollbar,
.kechengList::-webkit-scrollbar,
.biji_list_box2::-webkit-scrollbar,
.dayi_box::-webkit-scrollbar {
  display: none;
  /* Chrome Safari */
}

.pingjia_body_list,
.kechengList,
.biji_list_box2,
.dayi_box {
  scrollbar-width: none;
  /* firefox */
  -ms-overflow-style: none;
  /* IE 10+ */
  // overflow-x: hidden;
  overflow-y: auto;
}

.comment-class {
    display: inline-block;
}
// 修改placeholder样式
@deep: ~">>>";

input::-webkit-input-placeholder {
  color: #999;
  font-size: 14px;
}

@deep: ~">>>";

input::-moz-input-placeholder {
  color: #999;
  font-size: 14px;
}

@deep: ~">>>";

input::-ms-input-placeholder {
  color: #999;
  font-size: 14px;
}

.kechengCurrent {
  color: #0c6ae6 !important;
}

.tabCurrent {
  color: #0c6ae6;
}
.jie_active {
  color: #0c6ae6 !important;
  background-color: #121212;
}
.jie_active2 {
  color: #0c6ae6 !important;
}

.shiting_active {
  color: #fff !important;
  background-color: #f13232;
}

.jw-icon-barlogo-new {
  display: none !important;
}

.jw-skin-bce .jw-button-color,
.jw-skin-bce .jw-text {
  display: none !important;
}

.tabActive {
  background-color: #333333;
  //   height: 48px;
  border-top: 2px solid #525252;
}

.w {
  // width: 1200px;
  // margin: 0 auto;
  .video_page {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 6;
      background-color: dimgray;
  }

  .vedio_top {
    width: 100%;
      height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
      background-color: #767676;
    padding: 0 40px;
    box-sizing: border-box;
  }

  .vedio_tit {
    display: flex;
    align-items: center;
    font-size: 20px;
    color: #fff;
    // font-weight: 700;
    img {
      width: 20px;
      height: 20px;
      margin-right: 40px;
      cursor: pointer;
    }
  }
  .vedio_body {

    display: flex;
    justify-content: space-between;
    width: 100%;
      /*height: 980px;*/
    background-color: #333333;
    padding: 20px 0;
    padding-top: 0;
      bottom: 0;
    box-sizing: border-box;
    // video {


    .vedio_rt {
      position: relative;
        /*transition: all linear 0.1s;*/
      // width: 516px;
        border-left: 1px solid rgba(0, 0, 0, 0.1);

      .toWidth {
        width: 32px;
        height: 40px;
        background: rgba(0, 0, 0, 1);
        opacity: 0.2;
        border-radius: 0px 20px 20px 0px;
        // text-align: center;
        line-height: 40px;
        position: absolute;
        top: 50%;
        left: 15px;
        transform: translate(-50%);
        cursor: pointer;

        img {
          width: 10px;
          height: 18px;
          margin-left: 8px;
          margin-top: 10px;
        }
      }

      .toWidth2 {
        top: 45%;
        left: -33px;
        transform: rotate(180deg);
        background-color: #525252;
      }

      //   color: #fff;
      .vedio_tabs {
        display: flex;
        align-items: center;
        width: 100%;
        height: 50px;
        background-color: #525252;
        color: #fff;

        .tabsList {
          width: 172px;
          height: 48px;
          text-align: center;
          font-size: 20px;
          color: #fff;
          cursor: pointer;
          line-height: 48px;
        }
      }

      .kechengList {
          height: 90%;
        // padding: 0 20px;
        // box-sizing: border-box;
        // padding-bottom: 50px;

        .mulu_tit {
          font-size: 18px;
          font-weight: 700;
          margin-top: 30px;
          color: #999;
        }

        .mulu_jie {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 100%;
            height: 50px;
          padding: 0 20px;
          box-sizing: border-box;
          cursor: pointer;
            /*border-bottom: 1px solid #565656;*/

          //   margin-bottom: 30px;
          .jie_left {
              font-size: 16px;
            display: flex;
            color: #999;
            align-items: center;

            img {
              width: 16px;
              height: 16px;
              margin-right: 10px;
            }
          }

          .jie_rigtht {
            .shiting {
              font-size: 12px;
              color: #999;
              display: flex;
              align-items: center;

              img {
                  width: 18px;
                  height: 18px;
                margin-right: 10px;
              }
            }

            .buy {
              font-size: 14px;
              color: #333;
            }
          }
        }
      }
      .dayi_box {
        width: 100%;
        height: 790px;
        padding: 30px;
        box-sizing: border-box;
        color: #999;
        font-size: 14px;
        overflow-y: auto;
        .dayi_list {
          padding: 10px 0;
          box-sizing: border-box;
          border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        }
        .dayi_content {
          padding: 10px 0;
          box-sizing: border-box;
        }

        .dayi_btm {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: 10px;
          .pinglun {
            display: flex;
            align-items: center;
            img {
              width: 18px;
              height: 15px;
              margin-right: 8px;
            }
          }
        }
      }
      textarea {
        width: 100%;
        background-color: #272727;
        color: #999;
        outline: none;
        resize: none;
        // width: 454px;
        height: 110px;
        border-radius: 6px;
        padding: 10px;
        box-sizing: border-box;
      }
      .biji_btn {
        position: absolute;
        right:0;
        bottom: -50px;
        width: 80px;
        height: 40px;
        background: rgba(12, 106, 231, 1);
        border-radius: 20px;
        font-size: 14px;
        color: #fff;
        text-align: center;
        line-height: 40px;
        margin-top: 10px;
        // margin-left: 375px;
        cursor: pointer;
      }
      .biji_btn2 {
        height: 30px;
        line-height: 30px;
        margin-left: 0;
      }
      .tips {
        font-size: 8px;
        color: #fff;
        height: 20px;
        padding: 0 5px;
        box-sizing: border-box;
        background: rgba(101, 101, 101, 1);
        border: 1px solid rgba(204, 204, 204, 1);
        border-radius: 4px;
        text-align: center;
      }

      .tips1 {
        position: absolute;
        left: 0;
        bottom: -25px;
        // right: 5px;
        // top: 5px;
      }

      .biji_top {
          position: relative;
        // width: 454px;
        margin: 0 auto;
      }

      .biji_box {
        padding: 30px;
        box-sizing: border-box;

        // .biji_list::-webkit-scrollbar {
        //   display: none; /* Chrome Safari */
        // }

        // .biji_list {
        //   scrollbar-width: none; /* firefox */
        //   -ms-overflow-style: none; /* IE 10+ */
        //   overflow-x: hidden;
        //   overflow-y: auto;
        // }
        .biji_list {
          // width: 454px;
          height: 570px;
          margin-top: 50px;
          color: #999;
          font-size: 14px;
          .none {
            font-size: 18px;
            text-align: center;
            margin-top: 100px;
          }
          .biji_list_top {
            color: #999;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin: 30px 0;

            .rrrow {
              width: 50px;
              position: relative;
              text-align: center;

              img {
                width: 9px;
                height: 12px;
                margin: 0 5px;
                cursor: pointer;
              }

              img:nth-child(2) {
                transform: rotate(180deg);
              }
            }
          }
          .biji_list_box2 {
            width: 100%;
            height: 500px;
            // background-color: red;
            overflow-y: auto;
          }
          .biji_list_body {
            width: 100%;
            margin-bottom: 30px;
            border-bottom: 1px solid rgba(255, 255, 255, 0.1);

            // opacity: 0.1;
            .biji_content,
            textarea {
              width: 100%;
              padding: 10px;
              box-sizing: border-box;
              background-color: #272727;
              border-radius: 6px;
              color: #999;
              margin-bottom: 15px;
              resize: none;
              outline: none;
            }

            .biji_btm {
              display: flex;
              align-items: center;
              justify-content: space-between;
              margin-bottom: 10px;

              .btm_left {
                font-size: 12px;
                color: #999;
              }

              .btm_rigth {
                text-align: right;
                width: 80px;
                position: relative;

                .tips2 {
                  position: absolute;
                  bottom: -25px;
                  right: 20px;
                }

                .tips3 {
                  position: absolute;
                  bottom: -25px;
                  right: 0;
                }

                img {
                  cursor: pointer;
                }

                img:nth-child(1) {
                  width: 12px;
                  height: 14px;
                  margin-right: 20px;
                }

                img:nth-child(2) {
                  width: 10px;
                  height: 14px;
                }
              }
            }
          }
          .biji_list_body:last-child {
            border: none;
          }
        }
      }

      .list_title {
        margin-bottom: 20px;
      }

      .pingjia_box {
        padding: 30px;
        box-sizing: border-box;

        .biji_body {
          font-size: 14px;
          color: #999;

          .pingjia_body_list {
            height: 550px;
          }

          .pinglun_list {
            display: flex;
            padding: 30px 0;
            box-sizing: border-box;
            border-bottom: 1px solid rgba(255, 255, 255, 0.1);

            .linglun_list_left {
              img {
                width: 31px;
                height: 31px;
                border-radius: 50%;
                margin-right: 10px;
              }
            }

            .pinglun_list_right {
              width: 400px;

              .pinglun_desc {
                font-size: 16px;
                margin: 30px 0;
              }

              .pinglun_time {
                font-size: 12px;
              }
            }
          }

          .none {
            text-align: center;
            margin-top: 100px;

            img {
              width: 40px;
              height: 40px;
              margin-bottom: 10px;
            }
          }
        }
      }
    }
  }
}
</style>
